import { render, staticRenderFns } from "./EnrolmentsUser.vue?vue&type=template&id=1064d538&scoped=true&"
import script from "./EnrolmentsUser.vue?vue&type=script&lang=js&"
export * from "./EnrolmentsUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1064d538",
  null
  
)

export default component.exports